"use strict";
var appn;
(function (appn) {
    var location;
    (function (location) {
        function reloadCurrentPage(withMessage) {
            appn.dialog.hide();
            appn.dialog.showLoading(withMessage);
            window.location = window.location.href.endsWithIgnoreCase('#') ? window.location.href.slice(0, -1) : window.location.href;
        }
        location.reloadCurrentPage = reloadCurrentPage;
        function buildQueryString(queryStringParams) {
            let queryString = appn.emptyString;
            if (queryStringParams && queryStringParams.length > 0)
                for (let i = 0; i < queryStringParams.length; i++)
                    queryString += (i === 0 ? '' : '&') + encodeURIComponent(queryStringParams[i].name.toString().trim()) + '=' + encodeURIComponent(queryStringParams[i].value.toString().trim());
            if (queryString.length > 0)
                queryString = '?' + queryString;
            return queryString;
        }
        location.buildQueryString = buildQueryString;
        function buildUrl(url, queryStringParams) {
            if (!queryStringParams)
                return url;
            return url + buildQueryString(queryStringParams);
        }
        location.buildUrl = buildUrl;
        function buildUrlWithQueryString(url, queryStringParams) {
            if (!url)
                return appn.emptyString;
            const queryString = buildQueryString(queryStringParams);
            return url + queryString;
        }
        location.buildUrlWithQueryString = buildUrlWithQueryString;
        function navTo(url, queryStringParams, withLoadingMessage, isNewWindow, loadInChild) {
            if (parent !== window && !loadInChild)
                return parent.appn.location.navTo(url, queryStringParams, withLoadingMessage, isNewWindow);
            if (!url)
                return;
            if (!isNewWindow) {
                appn.dialog.showLoading(withLoadingMessage);
                window.location = buildUrl(url, queryStringParams);
            }
            else
                window.open(buildUrl(url, queryStringParams), '_blank');
        }
        location.navTo = navTo;
        function urlContains(text) {
            return window.location.href.containsIgnoreCase(text);
        }
        location.urlContains = urlContains;
    })(location = appn.location || (appn.location = {}));
})(appn || (appn = {}));
